// This file is generated by a script. Do not edit this file directly.
import { cva } from 'cva';
import React from 'react';
import { Body } from "../Typography";
import { cn } from "../../common/utils";
import { Icon } from "../Icon";
import * as icons from "../../icons";

// Type guard function to validate IconType
var isIconType = function isIconType(icon) {
  return typeof icon === 'string' && Object.keys(icons).includes(icon);
};
var chipStyles = cva({
  base: 'cop-inline-flex cop-items-center cop-justify-center cop-gap-1.5 cop-rounded-[4px] cop-border cop-border-solid cop-box-border focus:cop-outline-none focus:cop-outline-[1.5px] focus:cop-outline-primary focus:cop-outline-offset-[1px] cop-cursor-pointer',
  variants: {
    variant: {
      "default": 'hover:cop-bg-[#F8F9FB] active:cop-bg-secondary cop-border-transparent',
      outlined: 'hover:cop-bg-[#F8F9FB] active:cop-bg-secondary cop-border-secondary',
      filled: 'cop-bg-secondary hover:cop-bg-input-gray active:cop-bg-[#C9CBCD] focus:cop-bg-secondary'
    },
    size: {
      lg: 'cop-px-3 cop-h-10',
      md: 'cop-px-3 cop-py-0.5',
      sm: 'cop-px-2 cop-py-0.5'
    },
    disabled: {
      "true": 'cop-pointer-events-none'
    }
  },
  defaultVariants: {
    variant: 'default',
    size: 'sm',
    disabled: false
  },
  compoundVariants: [{
    variant: 'default',
    disabled: true,
    "class": 'cop-bg-[#F8F9FB] cop-text-gray-300'
  }, {
    variant: 'outlined',
    disabled: true,
    "class": 'cop-bg-[#F8F9FB] cop-text-gray-300'
  }, {
    variant: 'filled',
    disabled: true,
    "class": 'cop-text-disabled cop-border-[#DFE1E4]'
  }, {
    variant: 'filled',
    disabled: false,
    "class": 'cop-border-transparent'
  }]
});
var chipIconStyles = cva({
  variants: {
    size: {
      sm: 'cop-h-[11px] cop-w-[11px]',
      md: 'cop-h-3 cop-w-3',
      lg: 'cop-h-3 cop-w-3'
    }
  },
  defaultVariants: {
    size: 'sm'
  }
});
var RenderIcon = function RenderIcon(_ref) {
  var icon = _ref.icon,
    className = _ref.className;
  if (!icon) {
    return null;
  }
  if (typeof icon === 'string' && isIconType(icon)) {
    return /*#__PURE__*/React.createElement(Icon, {
      icon: icon,
      className: className
    });
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, icon);
};
export var Chip = function Chip(_ref2) {
  var _ref2$variant = _ref2.variant,
    variant = _ref2$variant === void 0 ? 'default' : _ref2$variant,
    label = _ref2.label,
    _ref2$size = _ref2.size,
    size = _ref2$size === void 0 ? 'sm' : _ref2$size,
    className = _ref2.className,
    prefixIcon = _ref2.prefixIcon,
    disabled = _ref2.disabled,
    onClick = _ref2.onClick,
    onClose = _ref2.onClose,
    ariaPressed = _ref2['aria-pressed'];
  return /*#__PURE__*/React.createElement("div", {
    className: cn(chipStyles({
      variant: variant,
      size: size,
      disabled: disabled
    }), className),
    "aria-disabled": disabled,
    role: "button",
    tabIndex: disabled ? -1 : 0 // Prevents focus when disabled
    ,
    onClick: !disabled ? onClick : undefined // Prevents click when disabled
    ,
    "aria-pressed": ariaPressed
  }, /*#__PURE__*/React.createElement(RenderIcon, {
    icon: prefixIcon,
    className: chipIconStyles({
      size: size
    })
  }), /*#__PURE__*/React.createElement(Body, {
    size: size !== 'sm' ? 'base' : 'sm'
  }, label), Boolean(onClose) ? /*#__PURE__*/React.createElement("span", {
    onClick: function onClick(e) {
      e.stopPropagation();
      onClose === null || onClose === void 0 || onClose(e);
    }
  }, /*#__PURE__*/React.createElement(Icon, {
    icon: "Close",
    className: chipIconStyles({
      size: size
    })
  })) : null);
};
